import { toast } from 'react-toastify';

export const fAlertToast = (message, type = 'success') => {
  const options = {
    position: 'top-right',
    autoClose: 3000, // Closes after 3 seconds
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'light',
  };

  if (type === 'success') {
    toast.success(message, options);
  } else if (type === 'error') {
    toast.error(message, options);
  } else if (type === 'info') {
    toast.info(message, options);
  } else if (type === 'warning') {
    toast.warn(message, options);
  }
};
